import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, role }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="h-screen w-screen flex items-center justify-center bg-background">
        <div className="text-sm tracking-[0.2em] uppercase text-muted-foreground">Loading</div>
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (role && user.role !== role) {
    if (user.role === "platform_admin") return <Navigate to="/studio" replace />;
    return <Navigate to="/portal" replace />;
  }
  return children;
}
